export default "__VITE_ASSET__BlmF19ZY__"